import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/swiper-bundle.css';

export default defineNuxtPlugin(() => {
  return {
    provide: {
      swiper: {
        Swiper,
        SwiperSlide,
      },
    },
  };
});
